<script>
  export default {
    name: "EdaOrderErrors",
    inject: ['$validator'],
    data: function () {
      return {
        showErrors: false
      }
    },
    mounted() {
      const dict = {
        custom: {
          'customerName': {
            required: this.$t('orderErrors.fullName.required'),
            regex: this.$t('orderErrors.fullName.regex'),
          },
          "customerTelephone": {
            required: () => this.$t('orderErrors.telephone.required'),
            min: () => this.$t('orderErrors.telephone.min'),
          },
          "customerEmail": {
            required: this.$t('orderErrors.email.required'),
            email: this.$t('orderErrors.email.email'),
          },

          "customerAddressLine1": {
            required: this.$t('orderErrors.addressLine1.required'),
          },

          "houseApproved": {
            required: this.$t('orderErrors.houseApproved.required'),
          },

          "retailerOrderRef": {
            required: this.$t('orderErrors.retailerReference.required'),
            max: this.$t('orderErrors.retailerReference.max'),
          },

          "customerPostCode": {
            digits: this.$t('orderErrors.postCode.digits'),
            required: this.$t('orderErrors.postCode.required'),
          },

          "customerPlace": {
            required: this.$t('orderErrors.place.required')
          }
        }
      };

      this.$validator.localize('en', dict);
    },
    methods: {
      toggle() {
        this.showErrors = !this.showErrors;
      }

    }
  }

</script>


<template>
    <div>
        <div :class="{'edaerr__panel--hidden': errors.items.length == 0 }" class="edaerr__panel">

            <h2 class="edaerr__heading">
                <svg class="edaerr__panel-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><g><g><path d="M95.3,82.1L80.4,56.3c-2.9-4.9-7.5-13-10.4-18L55.2,12.6c-2.9-4.9-7.5-4.9-10.4,0L30,38.4    c-2.9,4.9-7.5,13-10.4,18L4.7,82.1c-2.9,4.9-0.5,9,5.2,9h80.2C95.8,91.1,98.1,87,95.3,82.1z M52.9,76.1c-0.8,0.7-1.8,1.1-2.9,1.1    c-1.1,0-2.1-0.4-2.9-1.1c-0.8-0.7-1.2-1.7-1.2-3c0-1.1,0.4-2.1,1.2-2.9s1.8-1.2,2.9-1.2c1.1,0,2.1,0.4,2.9,1.2    c0.8,0.8,1.2,1.7,1.2,2.9C54.1,74.4,53.7,75.4,52.9,76.1z M53.9,46l-1.2,13.4c-0.1,1.6-0.4,2.8-0.8,3.7c-0.4,0.9-1.1,1.3-2.1,1.3    c-1,0-1.7-0.4-2-1.2c-0.4-0.8-0.7-2.1-0.8-3.8l-0.9-13c-0.2-2.5-0.2-4.4-0.2-5.5c0-1.5,0.4-2.7,1.2-3.5c0.8-0.8,1.8-1.3,3.1-1.3    c1.6,0,2.6,0.5,3.1,1.6c0.5,1.1,0.8,2.6,0.8,4.7C54.1,43.6,54,44.8,53.9,46z"></path></g></g></svg>
                {{ $t('orderErrors.pleaseFix') }}
            </h2>

            <ol class="edaerr__list">
                <template v-for="error in errors.items">
                    <li class="edaerr__item" v-bind:key="error.id">
                        {{error.msg}}
                    </li>
                </template>
            </ol>
        </div>
    </div>
</template>

<style>


    .edaerr__panel-icon {
        margin-right: 0.25em;
        width: 1em;
        margin-bottom: -0.1em;
        fill: #f53535;
    }

    .edaerr__list {
        padding: 0 1em;
    }

    .edaerr__item {
        font-size: 1em;
        padding-bottom: 0.35em;
    }

    .edaerr__panel {
        position: relative;
        padding: 1em 1em;
        width: 100%;
        color: #000000;
        max-height: 100em;
        transition: all 0.1s cubic-bezier(.41, -0.2, .24, 1.05);
    }

    .edaerr__panel--hidden {
        opacity: 0;
        max-height: 0;
        padding: 0;
        transform: translateY(1em);
        pointer-events: none;
    }

    .edaerr__heading {
        font-weight: 400;
        color: red;
        font-size: 1.25em;
    }
</style>

